import { Link } from "react-router-dom";
import { Stack, useTheme } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import ProgressBarTitle from "src/components/Displays/ProgressBarTitle";

const FaqOverview = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Stack gap={8}>
      <Stack gap={3}>
        <ProgressBarTitle
          fontWeight="bold"
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq1")}
        />
        <ProgressBarTitle
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq1Answer")}
        />
      </Stack>

      <Stack gap={3}>
        <ProgressBarTitle
          fontWeight="bold"
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq2")}
        />
        <ProgressBarTitle
          color={theme.palette.grey[500]}
          text={
            <Trans
              i18nKey={
                t(
                  "page.tariff.faqModal.faq2Answer"
                ) as "page.tariff.faqModal.faq2Answer"
              }
              t={t}
              components={{
                linkTag: (
                  <Link
                    to="https://www.lichtblick.de/wissen/zuhause/variable-stromtarife/"
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                ),
              }}
            />
          }
        />
      </Stack>

      <Stack gap={3}>
        <ProgressBarTitle
          fontWeight="bold"
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq3")}
        />
        <ProgressBarTitle
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq3Answer")}
        />

        <ProgressBarTitle
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq3AnswerPoint1")}
        />
      </Stack>

      <Stack gap={3}>
        <ProgressBarTitle
          fontWeight="bold"
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq4")}
        />
        <ProgressBarTitle
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq4Answer")}
        />
      </Stack>

      <Stack gap={3}>
        <ProgressBarTitle
          fontWeight="bold"
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq5")}
        />
        <ProgressBarTitle
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq5Answer")}
        />

        <Stack gap={3}>
          <Stack gap={3}>
            <Stack direction={"row"} gap={2}>
              <Stack color={theme.palette.grey[500]}>•</Stack>
              <Stack>
                <ProgressBarTitle
                  color={theme.palette.grey[500]}
                  text={t("page.tariff.faqModal.faq5AnswerPoint1")}
                />
              </Stack>
            </Stack>
          </Stack>

          <Stack gap={3}>
            <Stack direction={"row"} gap={2}>
              <Stack color={theme.palette.grey[500]}>•</Stack>
              <Stack>
                <ProgressBarTitle
                  color={theme.palette.grey[500]}
                  text={t("page.tariff.faqModal.faq5AnswerPoint2")}
                />
              </Stack>
            </Stack>
          </Stack>

          <Stack direction={"row"} gap={2}>
            <Stack color={theme.palette.grey[500]}>•</Stack>
            <Stack>
              <ProgressBarTitle
                color={theme.palette.grey[500]}
                text={t("page.tariff.faqModal.faq5AnswerPoint3")}
              />
            </Stack>
          </Stack>

          <Stack direction={"row"} gap={2}>
            <Stack color={theme.palette.grey[500]}>•</Stack>
            <Stack>
              <ProgressBarTitle
                color={theme.palette.grey[500]}
                text={t("page.tariff.faqModal.faq5AnswerPoint4")}
              />
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      <Stack gap={3}>
        <ProgressBarTitle
          fontWeight="bold"
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq6")}
        />
        <ProgressBarTitle
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq6Answer")}
        />
      </Stack>

      <Stack gap={3}>
        <ProgressBarTitle
          fontWeight="bold"
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq7")}
        />
        <ProgressBarTitle
          color={theme.palette.grey[500]}
          text={t("page.tariff.faqModal.faq7Answer")}
        />
      </Stack>
    </Stack>
  );
};

export default FaqOverview;
